module.exports = __webpack_public_path__ + "img/r-214.040b9a45.jpg";